export var STORE_KEYS = {
    accessTokenKey: 'accessToken',
    clientKey: 'client',
    correlationIdKey: 'correlationId',
    envKey: 'cbr-mfe__selected-env',
    givenNameKey: 'givenName',
    isCbrExecution: 'cbr-mfe_isCbrExecution',
    isProfileEnabled: 'cbr-mfe_isProfileEnabled',
    idTokenKey: 'idToken',
    languageKey: 'language',
    otpErrorCodeKey: 'otpErrorCode',
    otpErrorKey: 'otpError',
    selectedIdKey: 'selectedAccountId',
    selectedAccount: 'selectedAccount',
    otpErrorCallbackParams: 'otpErrorCallbackParams'
};
export var STORE_LOCATIONS = {
    session: 'session',
    local: 'local'
};
